var _style, _path, _g, _g2, _g3, _g4, _g5, _g6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPinpointNoBg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_00000088114925450003818150000017208581734288833977_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 131.2558,
    y1: 172.2534,
    x2: 380.7442,
    y2: 172.2534
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EC2227"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F15B27"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M251.25,30.95L136,97.49c-2.94,1.7-4.75,4.83-4.75,8.22v133.08c0,3.39,1.81,6.53,4.75,8.22l115.25,66.54 c2.94,1.7,6.56,1.7,9.5,0L376,247.02c2.94-1.7,4.75-4.83,4.75-8.22V105.71c0-3.39-1.81-6.53-4.75-8.22L260.75,30.95 C257.81,29.26,254.19,29.26,251.25,30.95z M330.25,220.6l-69.5,40.13c-2.94,1.7-6.56,1.7-9.5,0l-69.5-40.13 c-2.94-1.7-4.75-4.83-4.75-8.22v-80.25c0-3.39,1.81-6.53,4.75-8.22l69.5-40.13c2.94-1.7,6.56-1.7,9.5,0l69.5,40.13 c2.94,1.7,4.75,4.83,4.75,8.22v80.25C335,215.77,333.19,218.91,330.25,220.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000063616853723249434350000012793831566561678266_",
    gradientUnits: "userSpaceOnUse",
    x1: 131.8799,
    y1: 380.3449,
    x2: 241.577,
    y2: 380.3449
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EC2227"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F15B27"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000063616853723249434350000012793831566561678266_)"
    },
    d: "M240,338.76L136.62,278.8 c-2.26-1.31-5.04,0.53-4.72,3.12l24.69,197.63c0.38,3.01,4.37,3.81,5.87,1.18l78.69-137.67C242.02,341.55,241.5,339.63,240,338.76 z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinpointNoBg);
export default __webpack_public_path__ + "static/media/pinpoint_no_bg.98515a09638645a10101f574efb06f26.svg";
export { ForwardRef as ReactComponent };